/**
 * Персист UI-состояния (фильтры, сортировки) в localStorage —
 * свои значения на каждого юзера, переживают перезагрузку и переходы.
 */
export function loadPersisted<T>(userId: string, key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(`wml-insta.state.${userId}.${key}`);
    if (raw) return JSON.parse(raw) as T;
  } catch {
    /* битые данные / нет доступа — дефолт */
  }
  return fallback;
}

export function savePersisted(userId: string, key: string, value: unknown): void {
  try {
    localStorage.setItem(`wml-insta.state.${userId}.${key}`, JSON.stringify(value));
  } catch {
    /* тихо */
  }
}
